import { create } from 'zustand';

interface SceneSelectionState {
  selectedPartRef: string | null;
  hoveredPartRef: string | null;
  setSelected: (ref: string | null) => void;
  setHovered: (ref: string | null) => void;
  clear: () => void;
}

export const useSceneSelection = create<SceneSelectionState>((set) => ({
  selectedPartRef: null,
  hoveredPartRef: null,
  setSelected: (ref) => set({ selectedPartRef: ref }),
  setHovered: (ref) => set({ hoveredPartRef: ref }),
  clear: () => set({ selectedPartRef: null, hoveredPartRef: null }),
}));
